export enum License {
    Enterprise = "enterprise",
    Free = "free",
}
